import styled from 'styled-components';

export const LiteTradeNotificationTopUpStyled = styled.div`
    display: flex;
    justify-content: end;
    button {
        font-size: 16px;
        font-weight: 600;
        color: var(--color-white-60);
        &:hover {
            color: var(--color-white-60) !important;
        }
    }
`;
